import styled from "styled-components"
import HeaderComponent from "../Common/Header"
import Footer from "../Common/Footer"
import teamImage from "../../../app/assets/img/marco.png"
import missionImage from "../../../app/assets/img/mission-image.jpg"
import valuesImage from "../../../app/assets/img/values-image.jpg"

const PageWrapper = styled.div`
  background: #f2f6fa;
  color: #172c42;
`

const HeroSection = styled.section`
  position: relative;
  min-height: clamp(560px, 72vh, 760px);
  display: flex;
  align-items: flex-end;
  padding: clamp(3rem, 7vw, 6.5rem) 0;
  color: #ffffff;
  isolation: isolate;
  overflow: hidden;
  background: #0a1f35 url("/img/about-hero.jpg") center 55% / cover no-repeat;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    z-index: -2;
    background: linear-gradient(90deg, rgba(5, 19, 34, 0.94) 0%, rgba(7, 24, 42, 0.72) 48%, rgba(7, 24, 42, 0.24) 100%);
  }

  &::after {
    content: "";
    position: absolute;
    inset: auto 0 0;
    height: 1px;
    z-index: -1;
    background: rgba(255, 255, 255, 0.28);
  }
`

const HeroContent = styled.div`
  width: min(1280px, 90vw);
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 780px) minmax(220px, 1fr);
  gap: 3rem;
  align-items: end;

  @media (max-width: 1080px) {
    grid-template-columns: 1fr;
  }
`

const Eyebrow = styled.p`
  margin: 0 0 1rem;
  color: #91c7f2;
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0.18em;
  text-transform: uppercase;
`

const HeroTitle = styled.h1`
  max-width: 820px;
  color: #ffffff;
  font-size: clamp(3rem, 7vw, 6.4rem);
  line-height: 0.92;
  letter-spacing: -0.06em;
`

const HeroSubtitle = styled.p`
  max-width: 660px;
  margin: 2rem 0 0;
  color: rgba(255, 255, 255, 0.82);
  font-size: clamp(1.05rem, 1.8vw, 1.3rem);
  line-height: 1.65;
`

const HeroSideNote = styled.p`
  margin: 0;
  padding: 1.25rem 0 0 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.34);
  border-left: 1px solid rgba(255, 255, 255, 0.34);
  color: rgba(255, 255, 255, 0.68);
  font-size: 0.9rem;
  line-height: 1.6;

  @media (max-width: 1080px) {
    max-width: 620px;
    padding-left: 0;
    border-left: 0;
  }
`

const Section = styled.section`
  width: min(1280px, 90vw);
  margin: 0 auto;
  padding: clamp(5rem, 10vw, 9rem) 0;
  border-bottom: 1px solid #cad7e3;
`

const ContentContainer = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(360px, 0.95fr);
  gap: clamp(3rem, 8vw, 8rem);
  align-items: center;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 2.5rem;
  }
`

const ImageContainer = styled.div`
  position: relative;
  min-height: 540px;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    inset: 1.25rem -1.25rem -1.25rem 1.25rem;
    z-index: -1;
    border: 1px solid #9cb6cd;
  }

  @media (max-width: 900px) {
    min-height: 420px;
  }
`

const ImageContainerTeam = styled(ImageContainer)`
  background: #0e2945;

  &::after {
    border-color: #337abd;
  }
`

const Image = styled.img`
  width: 100%;
  height: 100%;
  min-height: inherit;
  display: block;
  object-fit: cover;
`

const TextContainer = styled.div`
  text-align: left;
`

const SectionIndex = styled.p`
  margin: 0 0 1rem;
  color: #337abd;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.18em;
  text-transform: uppercase;
`

const SectionTitle = styled.h2`
  max-width: 600px;
  color: #102f4f;
  font-size: clamp(2.5rem, 5vw, 4.6rem);
  line-height: 0.98;
  letter-spacing: -0.055em;
`

const SectionDescription = styled.p`
  max-width: 620px;
  margin: 1.75rem 0 0;
  color: #52687c;
  font-size: 1.08rem;
  line-height: 1.75;
`

const ValuesList = styled.ul`
  list-style: none;
  margin: 2.25rem 0 0;
  padding: 0;
  border-top: 1px solid #c6d4df;

  li {
    display: grid;
    grid-template-columns: 130px 1fr;
    gap: 1.25rem;
    padding: 1rem 0;
    border-bottom: 1px solid #c6d4df;
    color: #52687c;
    line-height: 1.55;
  }

  strong {
    color: #163a5f;
  }

  @media (max-width: 520px) {
    li {
      grid-template-columns: 1fr;
      gap: 0.25rem;
    }
  }
`

const CTASection = styled.section`
  margin-top: clamp(4rem, 9vw, 8rem);
  color: #ffffff;
  background:
    linear-gradient(90deg, rgba(7, 28, 50, 0.96), rgba(12, 52, 87, 0.86)),
    url("/img/cta-background.jpg") center 48% / cover no-repeat;
`

const CTAInner = styled.div`
  width: min(1280px, 90vw);
  margin: 0 auto;
  padding: clamp(4rem, 8vw, 7rem) 0;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 2rem;
  align-items: end;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
    align-items: start;
  }
`

const CTAHeading = styled.h2`
  max-width: 780px;
  color: #ffffff;
  font-size: clamp(2.4rem, 5vw, 4.5rem);
  line-height: 1;
  letter-spacing: -0.05em;
`

const CTAButton = styled.a`
  min-height: 54px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 1.5rem;
  border: 1px solid rgba(255, 255, 255, 0.55);
  border-radius: 3px;
  color: #ffffff;
  font-weight: 800;
  text-decoration: none;
  transition:
    background 0.2s ease,
    color 0.2s ease;

  &:hover {
    background: #ffffff;
    color: #103c68;
  }
`

const Hero = () => (
  <HeroSection>
    <HeroContent>
      <div>
        <Eyebrow>Entreprise locale · Neuville</Eyebrow>
        <HeroTitle>Une gestion proche du terrain.</HeroTitle>
        <HeroSubtitle>
          TB Gestion Immobilière mise sur des suivis clairs, des décisions documentées et une relation simple avec les propriétaires et les
          locataires.
        </HeroSubtitle>
      </div>
      <HeroSideNote>Portneuf · Couronne ouest de Québec · Gestion locative et coordination des opérations</HeroSideNote>
    </HeroContent>
  </HeroSection>
)

const Mission = () => (
  <Section>
    <ContentContainer>
      <ImageContainer>
        <Image src={missionImage} alt="Immeuble résidentiel dans la région de Québec" />
      </ImageContainer>
      <TextContainer>
        <SectionIndex>01 · Notre rôle</SectionIndex>
        <SectionTitle>Garder le quotidien sous contrôle.</SectionTitle>
        <SectionDescription>
          <strong>TB Gestion Immobilière</strong> aide les propriétaires à déléguer le quotidien de leurs immeubles sans perdre le fil. Nous
          définissons le mandat, documentons les suivis et communiquons les décisions à prendre au bon moment.
        </SectionDescription>
      </TextContainer>
    </ContentContainer>
  </Section>
)

const Values = () => (
  <Section>
    <ContentContainer>
      <TextContainer>
        <SectionIndex>02 · Notre méthode</SectionIndex>
        <SectionTitle>Trois principes. Une façon de travailler.</SectionTitle>
        <ValuesList>
          <li>
            <strong>Transparence</strong>
            <span>Partager l’information utile, même lorsqu’une décision est difficile.</span>
          </li>
          <li>
            <strong>Proactivité</strong>
            <span>Planifier les échéances et signaler rapidement les situations qui demandent une action.</span>
          </li>
          <li>
            <strong>Respect</strong>
            <span>Traiter propriétaires, locataires et fournisseurs avec constance et professionnalisme.</span>
          </li>
        </ValuesList>
      </TextContainer>
      <ImageContainer>
        <Image src={valuesImage} alt="Architecture résidentielle de la région" />
      </ImageContainer>
    </ContentContainer>
  </Section>
)

const Team = () => (
  <Section>
    <ContentContainer>
      <ImageContainerTeam>
        <Image src={teamImage} alt="Marco Tremblay de TB Gestion Immobilière" />
      </ImageContainerTeam>
      <TextContainer>
        <SectionIndex>03 · Notre équipe</SectionIndex>
        <SectionTitle>Une personne-ressource qui connaît votre dossier.</SectionTitle>
        <SectionDescription>
          <strong>Marco Tremblay</strong> assure la direction et la coordination des dossiers. L’équipe organise les demandes locatives, les suivis
          administratifs et les interventions sur le terrain, puis fait appel aux fournisseurs et professionnels appropriés lorsque la situation
          l’exige.
        </SectionDescription>
      </TextContainer>
    </ContentContainer>
  </Section>
)

const CTA = () => (
  <CTASection>
    <CTAInner>
      <div>
        <Eyebrow>Premier échange</Eyebrow>
        <CTAHeading>Parlons de vos besoins de gestion.</CTAHeading>
      </div>
      <CTAButton href="/faire-une-demande">Demander une consultation</CTAButton>
    </CTAInner>
  </CTASection>
)

const AboutPage = () => (
  <PageWrapper>
    <HeaderComponent />
    <main id="contenu-principal">
      <Hero />
      <Mission />
      <Values />
      <Team />
      <CTA />
    </main>
    <Footer />
  </PageWrapper>
)

export default AboutPage
